
import Input from "../../../common/input/Input";

export default function FieldTitle({ title, onChange }) {
	return (
		<>
			<Input
				onChange={onChange}
				value={title}
				label={"عنوان وبینار"}
				placeholder={"درمان حواس پرتی"}
			/>
		</>
	)
}
